import { render } from "./ModalStopSuppliers.vue?vue&type=template&id=61cc445b"
import script from "./ModalStopSuppliers.vue?vue&type=script&lang=js"
export * from "./ModalStopSuppliers.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__